import { Alert, CircularProgress, Modal, Snackbar, Box, FormControl, InputLabel, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { BlueHoverButton } from "../../../components/Inputs/BlueHoverButton";
import servConsultaAcesso from "../../../services/login/servConsultaAcesso";
import { style as modalStyle } from "../../../components/Loading/Loading";
import { WhiteInput } from "../../../components/Inputs/InputText";
import "./style.css";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { parse } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import { downloadConteudoBase64 } from "../../../infra/utils/DownloadFile";
import Popup from "../../../components/Popup";
import Anexos from "../Anexos";
import servAnexosConsultaAcesso from "../../../services/login/servAnexosConsultaAcesso";


const ResultadoAnalise = ({ setOpenPopup, recordForEdit, pesquisar }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [openErrorWindow, setOpenErrorWindow] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [analiseConsulta, setAnaliseConsulta] = useState(null);
    const [severity, setSeverity] = useState("error");
    const [openVisualizarOutrosAnexos, setOpenVisualizarOutrosAnexos] = useState(false);
    const [anexosAnalise, setAnexosAnalise] = useState(null);

    const handleCloseError = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenErrorWindow(false);
        }

        setOpenErrorWindow(false);
    }

    useEffect(() => {
        const recuperarAnaliseConsulta = async () => {
            try {
                setIsLoading(true);
                
                let dados = await servConsultaAcesso.RecuperarAnaliseConsultaDeAcesso(recordForEdit?.Id ?? recordForEdit?.row?.Id);
                
                setIsLoading(false);

                formatarData(dados);

                dados.Content.Situacao = setarSituacao(dados.Content.Situacao);
                setAnaliseConsulta(dados.Content);
            } catch (err) {
                setIsLoading(false);
                setErrorMessage(err.Message);
                setOpenErrorWindow(true);
            }
        }

        const recuperarAnexosAnalise = async () => {
            try {
                setIsLoading(true);

                let dados = await servAnexosConsultaAcesso.listarAnexos(recordForEdit?.row?.CodigoAnaliseAtual || recordForEdit?.CodigoAnaliseAtual);

                setIsLoading(false);

                setAnexosAnalise(dados.Content);
            }catch (err) {
                setIsLoading(false);
            }
        }
        
        recuperarAnexosAnalise();
        recuperarAnaliseConsulta();
    }, []);

    const formatarData = (dados) => {
        let dataAnaliseF = dados.Content.DataAnalise;

        dataAnaliseF = parse(dataAnaliseF, 'dd/MM/yyyy HH:mm:ss', new Date());

        dados.Content.DataAnalise = dataAnaliseF;
    }

    const setarSituacao = (situacao) => {
        let txtSituacao = "";

        switch (situacao) {
            case 0:
                txtSituacao = "Em digitação"
                break;
            case 1:
                txtSituacao = "Favorável, Sem restrições"
                break;
            case 2:
                txtSituacao = "Favorável, Com ressalvas"
                break;
            case 3:
                txtSituacao = "Inviabilidade técnica, necessidade de obras"
                break;
            case 4:
                txtSituacao = "Reprovado"
                break;
            default:
                break;
        }

        return txtSituacao;
    }

    const visualizarParecerTecnico = async () => {
        if (recordForEdit === null) {
            return;
        }

        try {
            setIsLoading(true);

            if(analiseConsulta.CodigoDocumentoParecer === 0 || analiseConsulta.CodigoDocumentoParecer === null) {
                setOpenErrorWindow(true);
                setSeverity("warning");
                setErrorMessage("Não há documento de parecer técnico informado para esta análise.");
                setIsLoading(false);
                return;
            }

            setOpenErrorWindow(true);
            setSeverity("info");
            setErrorMessage("Iniciando download do documento...");

            const response = await servConsultaAcesso.VisualizarDocumentoParecer(analiseConsulta.Id);

            setOpenErrorWindow(true);
            setSeverity("success");
            setErrorMessage("Download iniciado com sucesso...");

            downloadConteudoBase64(response.Content.Nome + "." + response.Content.Extensao, response.Content.Arquivo);

            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
            setSeverity("error");

            setErrorMessage(err.response.data.Message);
            return setOpenErrorWindow(true);
        }
    }
    
    return (
        <div style={{ width: "100%", minWidth: 600, height: "100%" }}>
            <div>
                <FormControl variant="outlined" style={{ margin: '10px 0px 20px 35px', width: "35%" }}>
                    <InputLabel shrink style={{ color: "#B8B8B8" }} >
                        Data de análise
                    </InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                        <DatePicker 
                            fullWidth
                            inputFormat="dd/MM/yyyy"
                            value={analiseConsulta?.DataAnalise}
                            readOnly={true}
                            renderInput={({ inputRef, inputProps, InputProps }) => (
                                <>
                                    <WhiteInput ref={inputRef}  {...inputProps} sx={{color: "#fff"}} />
                                    <span style={{ position: "absolute", top: 38, right: 15, color: "white", svg: "white", input: "white", label: "white" }}>
                                        {InputProps?.endAdornment}
                                    </span>
                                </>
                            )}
                        />
                    </LocalizationProvider>
                </FormControl>
            </div>
            <div>
                <FormControl variant="outlined" style={{ margin: '5px 0px 20px 35px', width: '90%' }}>
                    <InputLabel shrink style={{ color: "#B8B8B8" }} >
                        Analista
                    </InputLabel>
                    <WhiteInput 
                        fullWidth
                        type="text"
                        value={analiseConsulta?.Usuario}
                        readOnly={true}
                    />
                </FormControl>
            </div>
            <div>
                <FormControl variant="outlined" style={{ margin: '5px 0px 20px 35px', width: '90%' }}>
                    <InputLabel shrink style={{ color: "#B8B8B8" }} >
                        Situação
                    </InputLabel>
                    <WhiteInput 
                        fullWidth
                        type="text"
                        value={analiseConsulta?.Situacao}
                        readOnly={true}
                    />
                </FormControl>
            </div>
            <div>
                <FormControl variant="outlined" style={{ margin: '5px 0px 20px 35px', width: '90%' }}>
                    <InputLabel shrink style={{ color: "#B8B8B8" }} >
                        Descrição do parecer técnico
                    </InputLabel>
                    <WhiteInput 
                        fullWidth
                        type="text"
                        minRows={4}
                        multiline
                        value={analiseConsulta?.Observacao}
                        readOnly={true}
                    />
                </FormControl>
            </div>
            <div style={{
                margin: "25px 40px",
                display: "flex",
                justifyContent: "flex-end",
                gap: "20px"
            }}>
                <BlueHoverButton onClick={() => setOpenPopup(false)}>Fechar</BlueHoverButton>
                <BlueHoverButton onClick={visualizarParecerTecnico}>Visualizar parecer técnico</BlueHoverButton>
                { anexosAnalise && anexosAnalise.length > 0 && (
                    <BlueHoverButton onClick={() => setOpenVisualizarOutrosAnexos(true)}>Outros anexos</BlueHoverButton>
                )}
            </div>

            <Snackbar open={openErrorWindow} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleCloseError}> 
                    <Alert onClose={handleCloseError} severity={severity} sx={{ width: '100%' }}>
                        {errorMessage}
                    </Alert>
            </Snackbar>

            <Modal open={isLoading}>
                <Box style={modalStyle}>
                    <CircularProgress color="inherit" />
                </Box>
            </Modal>

            <Popup title="Anexos" openPopup={openVisualizarOutrosAnexos} setOpenPopup={setOpenVisualizarOutrosAnexos} minHeight="100px">
                <Anexos 
                    setOpenPopup={setOpenVisualizarOutrosAnexos}
                    recordForEdit={recordForEdit}
                    anexos={anexosAnalise}
                />
            </Popup>
        </div>
    );
}

export { ResultadoAnalise };